
import {  Form, Row, Col } from "react-bootstrap";

const attachmentLabels = [
  {label:"Zdjęcie detektor obudowa zewnętrzna/tabliczka", id:"detector_enclosure"},
  {label:"Zdjęcie detektor głowica", id:"detector_head"},
  {label:"Zdjęcie rozdzielnica tabliczka znamionowa", id:"distribution_board_nameplate"},
    {label:"Zdjęcie rozdzielnica elewacja", id:"distribution_board_elevation"},
    {label:"Zdjęcie rozdzielnica wnętrze urządzenia", id:"distribution_board_interior"},
    {label:"Inne", id:"other"},
];
const aerationAttachmentLabels = [
  {label:"Zdjęcie przetwornika ciśnienia zewnętrzna obudowa", id:"pressure_transducer_exterior"},
  {label:"Zdjęcie przetwornika ciśnienia wewnątrz", id:"pressure_transducer_interior"},
  {label:"Zdjęcie rozdzielnica tabliczka znamionowa", id:"distribution_board_nameplate"},
    {label:"Zdjęcie rozdzielnica elewacja", id:"distribution_board_elevation"},
    {label:"Zdjęcie rozdzielnica wnętrze urządzenia", id:"distribution_board_interior"},
    {label:"Inne", id:"other"},
];

const InspectionProtocolFiles = ({onFileChange, type}) => {

  const labels = type === "aeration_inspection" ? aerationAttachmentLabels : attachmentLabels;

  const handleFileChange = (id, file) => {
    onFileChange({ [id]: file});
  };

  return (
    <div className="p-3 border rounded bg-white m-2">
      <h6 className="mb-4">Dodaj załącznik</h6>
      {labels.map((label, index) => (
        <Form.Group as={Row} className="align-items-center mb-2" key={index}>
          <Form.Label column sm={6} className="mb-0">
            {index + 1}. {label.label}
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="file"
                accept="image/*"
              size="sm"
              id={label.id}
              onChange={e => handleFileChange(label.id, e.target.files[0])}
            />
          </Col>
        </Form.Group>
      ))}
    </div>
  );
};

export default InspectionProtocolFiles;
